import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './LandingPage';
import LoginPage from './LoginPage';
import AssessmentApp from './AssessmentApp';
import ClientPortal from './components/portal/ClientPortal';
import VoiceBrandForm from './components/portal/VoiceBrandForm';
import TDATeamAssembly from './components/portal/TDATeamAssembly';
import TDALeaderForm from './components/portal/TDALeaderForm';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUserList from './components/admin/AdminUserList';
import AdminUserDetail from './components/admin/AdminUserDetail';
import AdminCreateAccount from './AdminCreateAccount';
import AdminCoupons from './components/admin/AdminCoupons';
import Terms from './Terms';
import Privacy from './Privacy';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/assessment" element={<AssessmentApp />} />
        <Route path="/results" element={
          <ProtectedRoute>
            <ClientPortal />
          </ProtectedRoute>
        } />
        <Route path="/results/voice-brand" element={
          <ProtectedRoute>
            <VoiceBrandForm />
          </ProtectedRoute>
        } />
        <Route path="/results/tda/assemble" element={
          <ProtectedRoute>
            <TDATeamAssembly />
          </ProtectedRoute>
        } />
        <Route path="/results/tda/questionnaire/:teamId" element={
          <ProtectedRoute>
            <TDALeaderForm />
          </ProtectedRoute>
        } />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* Admin portal — nested routes under AdminLayout */}
        <Route path="/admin" element={
          <ProtectedRoute requireAdmin>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUserList />} />
          <Route path="users/:userId" element={<AdminUserDetail />} />
          <Route path="create-account" element={<AdminCreateAccount />} />
          <Route path="coupons" element={<AdminCoupons />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
